const E = {
  init: function (n) {
    (void 0 === n && void 0 !== E.zg) || (E.zg = !!n), E.i || (E.i = !0);
  },
  destroy: function () {
    (E.i = !1), (E.zg = void 0), (E.Rd = void 0);
  },
  setLogger: function (n) {
    "function" == typeof n
      ? (E.init(), (E.Rd = n))
      : E.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function () {
    E.init(),
      E.zg
        ? (console.log("Disabling Braze logging"), (E.zg = !1))
        : (console.log("Enabled Braze logging"), (E.zg = !0));
  },
  info: function (n) {
    if (E.zg) {
      const o = "Braze: " + n;
      null != E.Rd ? E.Rd(o) : console.log(o);
    }
  },
  warn: function (n) {
    if (E.zg) {
      const o = "Braze SDK Warning: " + n + " (v6.5.0)";
      null != E.Rd ? E.Rd(o) : console.warn(o);
    }
  },
  error: function (n) {
    if (E.zg) {
      const o = "Braze SDK Error: " + n + " (v6.5.0)";
      null != E.Rd ? E.Rd(o) : console.error(o);
    }
  },
};
export default E;
